module.exports = __webpack_public_path__ + "static/media/icono_produccion_discografica.ffaa4056.svg";